import React, {useState} from "react";

import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {Dialog} from "../../../../designSystem/components/Dialog";
import {Typography} from "../../../../designSystem/components/Typography";
import {NAVIGATION_BAR_HEIGHT} from "../../../../designSystem/tokens/spacing";

import {BsrsFormResultView} from "../BsrsFormResultView";

import {FormPageLayout} from "../../../../components/layout/FormPageLayout";
import {LoadingDialog} from "../../../../components/DialogLoading";
import {NextStepButton} from "../../../../widgets/NextStepButton";

import {useCreateBsrsFollowUp} from "../../hooks/useCreateBsrsFollowUp";

export const BsrsResultFeature = ({
  score,
  answers,
  onSubmittedForm,
}) => {
  const [name, setName] = useState<string>('');
  const [telephone, setTelephone] = useState<string>('');
  const [pressureEvent, setPressureEvent] = useState<string>('');

  const { isLoading, submit } = useCreateBsrsFollowUp({
    name,
    telephone,
    pressureEvent,
    onCompleted: onSubmittedForm
  })

  return (
    <FormPageLayout
      height={NAVIGATION_BAR_HEIGHT.LARGE}
      body={
        <React.Fragment>
          <div className="p-6 flex flex-col flex-1 justify-between">
            <div className="flex flex-col gap-6">
              <BsrsFormResultView
                score={score}
                answers={answers}
                showDetail={true}
              />

              <Typography variant="body">
                若您有心理相關困擾，且願意留下您的姓名及聯繫電話，將有專人回電給您。
              </Typography>

              <div className="flex flex-col gap-2">
                <Typography variant="bodyBold">
                  姓名
                </Typography>
                <BaseInput
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-2">
                <Typography variant="bodyBold">
                  電話
                </Typography>
                <BaseInput
                  value={telephone}
                  onChange={(e) => setTelephone(e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-2">
                <Typography variant="bodyBold">
                  請描述近期的壓力事件
                </Typography>
                <BaseInput
                  value={pressureEvent}
                  onChange={(e) => setPressureEvent(e.target.value)}
                />
              </div>
            </div>
          </div>
          <Dialog isOpen={isLoading}>
            <LoadingDialog label="請稍候" />
          </Dialog>
        </React.Fragment>
      }
      footer={<NextStepButton onClick={submit} />}
    />
  )
}